import axios from 'axios';
import {
  POST_OTP_REQUEST,
  POST_OTP_SUCCESS,
  POST_OTP_FAILURE,
  POST_OTP_VERIFY_REQUEST,
  POST_OTP_VERIFY_SUCCESS,
  POST_OTP_VERIFY_FAILURE
} from 'Store/constants';
import { getChannel } from 'Utils/channel';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const postOtp = (formData, otpTypeEnum) => async dispatch => {
  try {

    dispatch({
      type: POST_OTP_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/users/onetimepassword`,
      method: 'post',
      data: { ...formData, otpTypeEnum },
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: POST_OTP_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: POST_OTP_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    return e.response;
  }
};

export const forgotPasswordPostOtp = formData => async dispatch => {
  try {
    dispatch({
      type: POST_OTP_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/users/onetimepassword/external-customer-id`,
      method: 'post',
      data: { ...formData },
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: POST_OTP_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: POST_OTP_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    return e.response;
  }
};


export const forgotPasswordVerifyOtpExtarnal = data => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: POST_OTP_VERIFY_REQUEST
      });

      const res = await axios.post('/users/verify/onetimepassword/external-customer-id', data);

      dispatch({
        type: POST_OTP_VERIFY_SUCCESS,
        payload: res.data
      });
      resolve();
    } catch (e) {

      dispatch({
        type: POST_OTP_VERIFY_FAILURE,
        payload: errorMessage
      });
      reject(e);
    }
  });
};

